/**
 * For exporting html to pdf.
 *
 * @param {string} exportElementSelector - css selector for root element that contains html that will be exported
 * @param {Node} headerElement - html element that contains header for report
 * @param {string|string[]} skipElementsSelector - css selector(s) for elements that will be skipped on export
 * @param {string} exportFilename - name of exported pdf
 *
 * TODO: enable specifying footer for pdf
 *
 **/

import moment from "moment";
import { exportDomToPdf } from "./pdf/exportDomToPdf";

const MARGIN = { left: 40, right: 40, top: 30, bottom: 30 };

const createExportClone = (exportElement, headerElement) => {
  const exportContainer = document.createElement("div");
  // container is hidden and styled in a way that allows it to be used with html2canvas
  exportContainer.style.width = "1700px";
  exportContainer.style.position = "absolute";
  exportContainer.style.top = 0;
  exportContainer.style.left = "-100000px";

  const exportClone = exportElement.cloneNode(true);
  if (headerElement) {
    exportContainer.append(headerElement);
  }
  exportContainer.append(exportClone);

  exportElement.parentElement.append(exportContainer);

  return exportContainer;
};

export const exportHtmlToPdf = async (
  exportElementSelector,
  headerElement,
  skipElementsSelector,
  exportFilename = `report-${moment().format("YYYY-MM-DD")}.pdf`
) => {
  const exportElement = document.querySelector(exportElementSelector);

  if (!exportElement) {
    throw new Error(
      `Nothing to export, no element matches ${exportElementSelector}`
    );
  }

  const exportContainer = createExportClone(exportElement, headerElement);

  try {
    if (skipElementsSelector) {
      const skipSelector = Array.isArray(skipElementsSelector)
        ? skipElementsSelector.join(",")
        : skipElementsSelector;

      [].slice
        .call(exportContainer.querySelectorAll(skipSelector))
        .forEach(el => el.remove());
    }

    await exportDomToPdf(exportContainer, {
      filename: exportFilename,
      margin: MARGIN
    });
  } finally {
    exportContainer.remove();
  }
};
